import React from 'react';
import { Radio, Table, Space } from 'antd';
import { FormOutlined, AppstoreAddOutlined, TransactionOutlined } from '@ant-design/icons';
import SwitchShop from '../shop/switch-shop';
import { getCurrentShopId } from '../shop/get-current-shop';
import dayjs from  'dayjs';
import * as XLSX from "xlsx";

const statusMap = {
    0: '待结算',
    1: '结算中',
    2: '已结算',
    4: '已退款',
}

const cashoutMap = {
    'PENDING': '待结算',
    'SUCCESS': '已结算',
}

export const columns = [
    {
        title: '流水号',
        dataIndex: 'flowId',
    },
    {
        title: '渠道号',
        dataIndex: 'channelNo',
    },
    {
        title: '发生时间',
        dataIndex: 'updateTime',
        render: (text, re) => <>{dayjs(re?.pay?.updateTime || re.createTime).format('YYYY-MM-DD HH:mm:ss')}</>
    },
    {
        title: '备注',
        dataIndex: 'remark',
    },
    {
        title: '状态',
        dataIndex: 'pay.status',
        // fixed: 'right',
        render: (text, record) => {
            return <>{['PENDING', 'SUCCESS'].includes(record?.status) ? cashoutMap[record?.status] : statusMap[record?.pay?.status]}</>
        }
    },
    // {
    //     title: '订单金额(元)',
    //     dataIndex: 'pay.amount',
    //     render: (text, recode) => <>{recode?.pay?.amount/100}</>
    // },
    {
        fixed: 'right',
        title: '操作人',
        dataIndex: 'operator',
    },
    {
        fixed: 'right',
        title: '金额(元)',
        dataIndex: 'amount',
        render: (text) => <>{text/100}</>
    },
    {
        title: '操作',
        fixed: 'right',
        render: (text, record) => {
            return record?.pay?.payId ? <a href={`/pay/detail?payId=${record?.pay?.payId}`}>详情</a> : null;
        }
    }
];

export default () => {
    const [payList, setPayList] = React.useState([]);
    const [pagination, setPagination] = React.useState({
        current: 1,
        pageSize: 10,
        total: 0,
        simple: true,
        showSizeChanger: false,
    });
    const [incoming, setIncoming] = React.useState(0);
    const [expenditure, setExpenditure] = React.useState(0);
    const [yearMonth, setYearMonth] = React.useState(undefined);
    
    React.useEffect(() => {
        // 计算总收入
        setIncoming(payList.reduce((total, item) => {
            if(item.amount > 0) return total + item.amount;
            return total;
        }, 0) || 0);

        // 获取总支出
        setExpenditure(payList.reduce((total, item) => {
            if(item.amount < 0 && item.reasonCode.indexOf('CASH_OUT') !== 0) return total + item.amount;
            return total;
        }, 0) || 0);
    }, [payList]);

    // 获取订单列表
    const getOrderList = async (params) => {
        params = params || { page : 1 , pageSize: 10};
        let urlParams = new URLSearchParams();
        const shopId = await getCurrentShopId();
        urlParams.append('shopId', shopId);

        Object.keys(params).forEach(key => {
            if(params[key]) urlParams.append(key, params[key]);
        });
        
        const response = await fetch(`/api/finance/funding-flow?${urlParams.toString()}`);
        return await response.json();
    }

    const reloadData = async (params) => { 
        getOrderList(params).then(res => {
            setPayList(res?.data?.rows || []);
            setPagination({
                ...pagination, 
                current: params?.page || 1, 
                total: res?.data?.count || 0,
                pageSize: params?.pageSize || 10,
            });
        });
    }


    const onTableChange = (pagination) => {
        console.log('pagination', pagination);
        const {current, pageSize} = pagination;
        reloadData({page: current, pageSize});
        // setPagination(pagination);
    };

    React.useEffect(() => {
        reloadData();
    }, []);

    const onMonthChange = (month) => {
        if(month) {
            // setPagination({...pagination, pageSize: 1000});
            setYearMonth(month);
            reloadData({month, pageSize: 1000});
        }
        else{
            // setPagination({...pagination, pageSize: 10});
            reloadData();
        }
    };


    const onImportClick = () => {
        let detailData = payList.map((item) => {
            return {
                流水号: item.flowId,
                支付单号: item?.pay?.payId,
                订单号: item?.pay?.orderId,
                地址: item?.a_city + item?.a_county + (item?.a_community || '') + item?.a_address,
                // 商品名称: item.goodsName,
                发生时间: dayjs(item?.pay?.updateTime).format('YYYY-MM-DD HH:mm:ss'),
                分销员: `${item.shareCustomerUsername || ''}${item.shareCustomerId || ''}`,
                备注: item.remark,
                商家备注: item.sellerRemark ? item.sellerRemark.split('$$').join('；\n') : '',
                '金额(元)': item.amount/100,
                '订单金额': item.pay.amount/100,
            };
        });

        let totalData = [
            {
                收入合计: incoming/100,
                支出合计: -expenditure/100,
                净收益: (incoming + expenditure)/100,
            },
        ];

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(detailData);
        const ws2 = XLSX.utils.json_to_sheet(totalData);
        XLSX.utils.book_append_sheet(wb, ws, "明细");
        XLSX.utils.book_append_sheet(wb, ws2, "合计");

        // 生成文件名
        // const currentDate = new Date().toISOString().slice(0, 10);
        const filename = `${yearMonth}对账单.xlsx`;
        console.log("filename", filename);

        const wbout = XLSX.writeFile(wb, filename);

        function s2ab(s) {
            const buf = new ArrayBuffer(s.length);
            const view = new Uint8Array(buf);
            for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
            return buf;
        }

        if (typeof window.navigator.msSaveBlob !== "undefined") {
            // IE 导出逻辑
            window.navigator.msSaveBlob(
                new Blob([wbout], { type: "application/octet-stream" }),
                filename
            );
        } else {
            // 非IE浏览器导出逻辑
            const blob = new Blob([s2ab(wbout)], {
                type: "application/octet-stream",
            });
            const url = URL.createObjectURL(blob);
            console.log("url", url);
            // const a = document.createElement("a");
            // a.href = url;
            // a.download = filename;
            // a.click();
            window.open(url);

            // 清理临时URL
            URL.revokeObjectURL(url);
        }
    };

    return (
        <div>
            <SwitchShop />
            <h2 className="admin-page-title">资金流水</h2>
            <Months onChange={onMonthChange} />
            {
                pagination.pageSize === 1000 && (
                    <div className="flex flex-wrap gap-3 mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                        <div className="text-sm text-blue-700">收入: {incoming/100}</div>
                        <div className="text-sm text-blue-700">支出: <span className="text-green-600">{-expenditure/100}</span></div>
                        <div className="text-sm text-blue-700">净收益: <span className="text-red-600 font-semibold">{(incoming + expenditure)/100}</span></div>
                        <a onClick={onImportClick} className="text-primary hover:underline text-sm">导出</a>
                    </div>
                )
            }
            <Table size='small' 
                pagination={pagination} 
                rowKey={'flowId'} 
                columns={columns} 
                dataSource={payList} 
                scroll={{ x: 'max-content' }}
                onChange={onTableChange}
            />
        </div>
    );
};

const Months = ({onChange}) => { 
    const [yearMonth, setYearMonth] = React.useState(undefined);
    // 当前月及之前6个月
    const months = Array.from({length: 6}, (v, k) => {
        const date = new Date();
        date.setMonth(date.getMonth() - k);
        const ym = dayjs(date).format('YYYYMM');
        return {label: `${date.getMonth() + 1}`, value: ym};
    });

    months.unshift({ label: '全部', value: undefined });

    const onOptionChange = (value) => {
        setYearMonth(value);
        onChange?.(value);
    }

    return (
        <div className="mb-4">
            <div className="text-sm text-text-secondary mb-2">按月查看{yearMonth !== undefined && <span>(已结算)</span>}</div>
            <Radio.Group options={months} optionType='button' onChange={(e) => onOptionChange?.(e.target.value)} />
            <span className="ml-2 text-text-secondary">月</span>
        </div>
    )
};